import { render, staticRenderFns } from "./ShiftVDPFactPrint.vue?vue&type=template&id=8ba8d372&scoped=true&"
import script from "./ShiftVDPFactPrint.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPFactPrint.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDPFactPrint.vue?vue&type=style&index=0&id=8ba8d372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba8d372",
  null
  
)

export default component.exports